import { List, Typography } from 'antd';
import React from 'react';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';

type Props = {
    files: Array<{
        title: string;
        url: string;
    }>;
    bottomBorder: boolean;
};

function DownloadFilesList(props: Props) {
    return (
        <List
            style={{
                borderBlockEnd: props.bottomBorder && '1px solid rgba(5,5,5,0.06)',
            }}
            size="large"
            dataSource={props.files}
            renderItem={(item) => (
                <List.Item>
                    <Typography.Link href={item.url}>{item.title}</Typography.Link>
                </List.Item>
            )}
        />
    );
}

export default (props) => (
    <PartWrapper {...props}>
        <DownloadFilesList {...props} />
    </PartWrapper>
);
